import displayJson from './displayJson';

const rev = 477;

//
// devLive is set when we want to connect to live server using a dev version of this site
// > then use default port, and url defined in VITE_API_URL_BASE
//
const devLive = import.meta.env.VITE_API_URL_BASE;

console.log(`env=${displayJson(import.meta.env, 2)}`);

//
// Find our site's url, and whether we use custom www ports
// (for local dev) or not
//
const getUrl = globalThis.location;
const hostAndPort = getUrl.host.split(':');
const host = hostAndPort[0];
const port = hostAndPort[1];
const cstmrUrlPrefix = host
  .split('.')[0];
const urlSuffix = devLive
                  || (host
                    .split('.')
                    .filter((field, index) => (!!index))
                    .reduce(
                      (prev, curr) => ((prev) ? `${prev}.${curr}` : curr),
                      null,
                    ));
const devUrlSuffix = host
  .split('.')
  .filter((field, index) => (!!index))
  .reduce(
    (prev, curr) => ((prev) ? `${prev}.${curr}` : curr),
    null,
  );
const webDevPorts = !!(port && (port !== '443') && (!devLive));

if (import.meta.env.VITE_API_URL_BASE
    || import.meta.env.DEV
    || import.meta.env.VITE_PX_DOMAIN_WWW
    || import.meta.env.VITE_PX_ANON_DOMAIN
    || import.meta.env.VITE_PX_ANON_DOMAIN_WWW
    || import.meta.env.VITE_PX_EU_DOMAIN) {
  //
  // These env variables are set only during dev, not in prod setups:
  //
  console.log(`import.meta.env.VITE_API_URL_BASE=${import.meta.env.VITE_API_URL_BASE}`);
  console.log(`import.meta.env.DEV=${import.meta.env.DEV}`);
  console.log(`import.meta.env.VITE_PX_DOMAIN_WWW=${import.meta.env.VITE_PX_DOMAIN_WWW}`);
  console.log(`import.meta.env.VITE_PX_ANON_DOMAIN=${import.meta.env.VITE_PX_ANON_DOMAIN}`);
  console.log(`import.meta.env.VITE_PX_ANON_DOMAIN_WWW=${import.meta.env.VITE_PX_ANON_DOMAIN_WWW}`);
  console.log(`import.meta.env.VITE_PX_EU_DOMAIN=${import.meta.env.VITE_PX_EU_DOMAIN}`);
  console.log(`urlSuffix=${urlSuffix}`);
}

// paxity.fr (corporate website):
const wwwDomain = ((!devLive) && import.meta.env.VITE_PX_DOMAIN_WWW)
                || (devLive && `${devUrlSuffix}:3004`)
                || `${urlSuffix}${(webDevPorts) ? ':3004' : ''}`;

// anon.paxity.fr (website):
const wwwAdminDomain = ((!devLive) && import.meta.env.VITE_PX_ANON_DOMAIN_WWW)
                      || `anon.${urlSuffix}${(webDevPorts) ? ':3003' : ''}`;

// anon.paxity.fr (servers):
const adminDomain = ((!devLive) && import.meta.env.VITE_PX_ANON_DOMAIN)
                  || `anon.${urlSuffix}${(webDevPorts) ? ':8443' : ''}`;

// town.paxity.fr (servers):
const cstmrDomain = ((!devLive) && import.meta.env.VITE_PX_CSTMR_DOMAIN)
                  || `${cstmrUrlPrefix}.${urlSuffix}${(webDevPorts) ? ':8444' : ''}`;

// town.paxity.fr (website):
const wwwCstmrDomain = ((!devLive) && import.meta.env.VITE_PX_CSTMR_DOMAIN_WWW)
                      || `${cstmrUrlPrefix}.${urlSuffix}${(webDevPorts) ? ':3002' : ''}`;

if (import.meta.env.DEV) {
  //
  // These env variables are set only during dev, not in prod setups:
  //
  console.log(`wwwDomain=${wwwDomain}`);
  console.log(`wwwAdminDomain=${wwwAdminDomain}`);
  console.log(`adminDomain=${adminDomain}`);
  console.log(`wwwCstmrDomain=${wwwCstmrDomain}`);
  console.log(`webDevPorts=${webDevPorts}`);
}

export default {
  rev,
  addLaterOn: true,
  enableTaskCreation: import.meta.env.DEV,
  live: !!devLive,
  liveUrlBase: devLive,
  dev: import.meta.env.DEV,
  demo: !!import.meta.env.VITE_DEMO,
  app: {
    stores: {
      android: 'https://play.google.com/store/apps/details?id=eu.paxity.mobile&hl=fr',
      ios: 'https://apps.apple.com/fr/app/paxity/id6755113604',
    },
  },
  anon: {
    www: {
      admin: `https://${wwwAdminDomain}/`,
      corporate: {
        home: `https://${wwwDomain}/`,
        login: `https://${wwwDomain}/login`,
      },
    },
    back: {
      urlPrefix: `https://back.anon.${adminDomain}/`,
      dev: {
        // getStatus: 'dev/status',
        discussErase: 'dev/discuss/erase',
      },
    },
    mob: {
      urlPrefix: `https://mob.anon.${adminDomain}/`,
    },
  },
  town: {
    www: {
      url: `https://${wwwCstmrDomain}/`,
    },
    back: {
      urlPrefix: `https://back.${cstmrDomain}/`,
      auth: {
        status: 'auth/status',
        login: 'auth/login',
        loginAdmin: 'auth/login/admin',
        loginStep: {
          check: 'auth/loginStep/check',
          totpAdd: 'auth/loginStep/totp/add',
          totpConfirm: 'auth/loginStep/totp/confirm',
          recoveryCodesIssue: 'auth/loginStep/recoveryCodes/issue',
          recoveryCodesSaved: 'auth/loginStep/recoveryCodes/saved',
          webauthnOptions: 'auth/loginStep/webauthn/options',
          webauthnCheck: 'auth/loginStep/webauthn/check',
          webauthnAdd: 'auth/loginStep/webauthn/add',
        },
        secondFactor: {
          list: 'auth/secondFactor/list',
          totpAdd: 'auth/secondFactor/totp/add',
          totpConfirm: 'auth/secondFactor/totp/confirm',
          totpDelete: 'auth/secondFactor/totp/delete',
          totpRename: 'auth/secondFactor/totp/rename',
          recoveryCodesRenew: 'auth/secondFactor/recoveryCodes/renew',
          webauthnOptions: 'auth/secondFactor/webauthn/options',
          webauthnAdd: 'auth/secondFactor/webauthn/add',
          webauthnDelete: 'auth/secondFactor/webauthn/delete',
          webauthnRename: 'auth/secondFactor/webauthn/rename',
          webauthnCheckOptions: 'auth/secondFactor/webauthn/checkOptions',
        },
        logout: 'auth/user/logout',
        refresh: 'auth/refresh',
        getInfo: 'auth/user/getInfo',
        passwordEdit: 'auth/pwd/edit', // NOSONAR
        recoverReq: 'auth/recover/req',
        recoverEnd: 'auth/recover/end',
        partner: 'auth/partner',
      },
      users: {
        block: 'users/block',
        listStaff: 'users/listStaff',
        members: {
          list: 'users/members/list',
          add: 'users/members/add',
          vet: 'users/members/vet',
          lock: 'users/members/lock',
          delete: 'users/members/delete',
        },
        uploadStaff: 'users/upload/staff',
        createStaff: 'users/staff/create',
        updateStaff: 'users/staff/update',
        password: { // NOSONAR
          reset: 'users/staff/password/reset', // NOSONAR
        },
        secondFactor: {
          reset: 'users/staff/secondFactor/reset',
        },
        role: {
          deletion: {
            fromUser: {
              list: 'users/role/deletion/fromUser/list',
              decide: 'users/role/deletion/fromUser/decide',
            },
            fromAdmin: 'users/role/deletion/fromAdmin',
          },
        },
      },
      groups: {
        upload: 'groups/upload',
        create: 'groups/create',
        update: 'groups/update',
        uploadLogo: 'groups/logo/upload',
        getGcat: 'groups/gcat',
        delete: 'groups/delete',
        ccat: {
          list: 'groups/ccat/list',
          set: {
            gcat: 'groups/ccat/set/gcat',
            gpid: 'groups/ccat/set/gpid',
          },
        },
      },
      info: {
        getConfig: 'info/config',
        geoZones: {
          getAllZonesPoly: 'info/geoZones/all/poly',
          getAllZonesInfo: 'info/geoZones/all/info',
          getTownPoly: 'info/geoZones/town/Poly',
        },
        getGroups: 'info/groups',
        getLanguages: 'info/languages',
        getLanguage: 'info/language',
        getCcatCodes: 'info/ccatCodes',
        getGroupLogo: 'info/groupLogo',
        settings: {
          cstmr: {
            set: 'info/settings/cstmr/set',
          },
        },
        build: 'info/build',
        config: 'info/config',
      },
      language: {
        list: 'language/list',
        get: 'language',
      },
      legal: {
        rev: 'legal/rev',
        cgu: (lang) => `legal/${lang}/cgu`,
        privacy: (lang) => `legal/${lang}/privacy`,
      },
      tasks: {
        init: 'tasks/init',
        assign: 'tasks/assign',
        change: 'tasks/change',
        list: 'tasks/list',
        counts: 'tasks/counts',
      },
      cases: {
        create: 'cases/create',
        createScope: 'cases/create/scope',
        listAll: 'cases/listAll',
        countsSummary: 'cases/countsSummary',
        getInfo: 'cases/getInfo',
        participate: 'cases/participate',
        handling: 'cases/handling',
        change: 'cases/change',
        leave: 'cases/leave',
        clearEmergency: 'cases/clearEmergency',
        enableVideo: 'cases/enableVideo',
        call: {
          init: 'cases/call/init',
          event: 'cases/call/event',
        },
      },
      calls: {
        status: 'calls/status',
      },
      discuss: {
        info: 'discuss/info',
        send: {
          txt: 'discuss/send/txt',
          qstn: 'discuss/send/qstn',
          media: 'discuss/send/media',
        },
        fetchReq: 'discuss/fetch/req',
        fetchRead: 'discuss/fetch/read',
        fetch: {
          media: 'discuss/fetch/media',
          flag: 'discuss/fetch/flag',
        },
      },
      gatherings: {
        create: 'gatherings/create',
        listAll: 'gatherings/listAll',
      },
      admin: {
        prune: {
          cases: 'admin/prune/cases',
          endUsers: 'admin/prune/endUsers',
        },
      },
      alerts: {
        create: 'alerts/create',
      },
      logs: {
        chunk: 'logs/chunk',
        list: 'logs/list',
        erase: 'logs/erase',
        actions: {
          chunk: 'logs/actions/chunk',
        },
        enable: 'logs/enable',
        disable: 'logs/disable',
      },
      geo: {
        zone: {
          create: 'geo/zone/create',
          upload: 'geo/zone/upload',
        },
      },
      plans: {
        file: {
          upload: 'plans/file/upload',
          list: 'plans/file/list',
          crop: 'plans/file/crop',
          cropDelete: 'plans/file/crop/delete',
          delete: 'plans/file/delete',
          original: 'plans/file/original/', // append /:floorplanFileUid
        },
        tiles: 'plans/tiles',
        save: 'plans/save',
        list: 'plans/list',
        edit: 'plans/edit',
        delete: 'plans/delete',
        tile: 'plans/tile/', // append /:floorplanUid/:z/:x/:y
        qrPositions: 'qr/plan/positions',
        features: {
          list: 'plans/features/list',
          save: 'plans/features/save',
          delete: 'plans/features/delete',
        },
      },
      qr: {
        create: {
          fromScratch: 'qr/create/fromScratch',
          fromTemplate: 'qr/create/fromTemplate',
        },
        edit: 'qr/edit',
        delete: 'qr/delete',
        setStatus: 'qr/status/set',
        list: 'qr/list',
        info: 'qr/info',
        invite: {
          create: 'qr/town/invites/create',
          list: 'qr/town/invites/list',
          statusSet: 'qr/town/invites/status/set',
        },
        template: {
          list: 'qr/template/list',
          edit: 'qr/template/edit',
          delete: 'qr/template/delete',
        },
        print: 'qr/print',
        folder: {
          list: 'qr/folder/list',
          create: 'qr/folder/create',
          delete: 'qr/folder/delete',
          edit: 'qr/folder/edit',
        },
        format: {
          list: 'qr/format/list',
          create: 'qr/format/create',
          edit: 'qr/format/edit',
          delete: 'qr/format/delete',
        },
        picto: {
          list: 'qr/picto',
          get: 'qr/picto', // append /:src
        },
        layout: {
          list: 'qr/layout/list',
          create: 'qr/layout/create',
          edit: 'qr/layout/edit',
          delete: 'qr/layout/delete',
        },
      },
      profile: {
        connect: {
          req: 'profile/connect/req',
          cancel: 'profile/connect/cancel',
          sts: 'profile/connect/sts',
        },
        devices: {
          list: 'profile/devices/list',
          disconnect: 'profile/devices/disconnect',
          delete: 'profile/devices/delete',
        },
        privileges: 'profile/privileges',
      },
      media: {
        image: {
          upload: 'media/image/upload',
          list: 'media/image/list',
          edit: 'media/image/edit',
          delete: 'media/image/delete',
          fetch: 'media/image/fetch',
          get: 'media/image/',
          thumb: 'media/thumb/',
        },
      },
      comm: {
        list: 'comm/list',
        info: 'comm/info',
        create: 'comm/create',
        edit: 'comm/edit',
        delete: 'comm/delete',
        assign: 'comm/assign',
        feedback: {
          list: 'comm/feedback/list',
          resolve: 'comm/feedback/resolve',
        },
      },
      poll: {
        list: 'poll/list',
        info: 'poll/info',
        create: 'poll/create/',
        edit: 'poll/edit/',
        delete: 'poll/delete',
        rslts: 'poll/rslts',
        rsltsInt: {
          answers: 'poll/rslts/intervals/answers',
          total: 'poll/rslts/intervals/total',
        },
        items: {
          list: 'poll/item/list',
          rslt: {
            msg: 'poll/item/rslt/msg',
          },
        },
        answers: {
          list: 'poll/answers/list',
          delete: 'poll/answers/delete',
        },
      },
      stats: {
        cases: {
          intervals: {
            ccatCnt: 'stats/cases/intervals/ccatCnt',
            rating: 'stats/cases/intervals/rating',
            duration: 'stats/cases/intervals/duration',
          },
        },
      },
      cstmrs: {
        search: 'cstmrs/search',
        iconFromDomain: 'cstmrs/icon/fromDomain',
      },
      partners: {
        invite: {
          edit: 'partners/invite/edit',
          notify: 'partners/invite/notify',
          setGroups: 'partners/invite/setGroups',
          setStatus: 'partners/invite/setStatus',
        },
        list: 'partners/list',
      },
      invite: {
        status: 'invite/sts',
        search: 'invite/search',
        confirmGovId: 'invite/confirmGovId',
        refuse: 'invite/refuse',
        finalize: 'invite/finalize',
      },
      logos: {
        get: 'logos/',
        // thumb: 'logos/thumb/',
      },
      licenses: {
        list: 'licenses/list',
      },
      sites: {
        list: 'sites/list',
        create: 'sites/create',
        edit: 'sites/edit',
        delete: 'sites/delete',
        geocode: 'sites/geocode',
      },
      settings: {
        device: {
          set: 'settings/device/set',
        },
        user: {
          set: 'settings/user/set',
        },
        customization: 'settings/customization',
        folder: {
          set: 'settings/folder/set',
        },
        domains: {
          pending: 'settings/domains/pending',
          claim: 'settings/domains/claim',
          verify: 'settings/domains/verify',
          cancel: 'settings/domains/cancel',
          remove: 'settings/domains/remove',
        },
        customer: {
          set: 'settings/customer/set',
        },
      },
      ws: {
        init: 'ws/init',
      },
    },
    demo: {
      urlPrefix: `https://demo.${cstmrDomain}/`,
      users: {
        generate: 'users/generate',
        count: 'users/count',
        getAll: 'users/getAll',
        getInfo: 'users/getInfo',
        getStatus: 'users/getStatus',
        robotMode: 'users/robotMode',
        play: 'users/play',
        invite: 'users/invite',
        sendHome: 'users/sendHome',
        move: 'users/move',
        flushAll: 'users/flushAll',
      },
      cases: {
        menu: 'cases/menu',
        create: 'cases/create',
        listAll: 'cases/listAll',
        report: 'cases/report',
        event: 'cases/event',
        thread: 'cases/thread',
        message: 'cases/message',
        photo: 'cases/photo',
        media: 'cases/media',
        flushAll: 'cases/flushAll',
        set: {
          location: 'cases/set/location',
          heading: 'cases/set/heading',
          emergency: 'cases/set/emergency',
        },
      },
      qr: {
        create: 'qr/create',
        activate: 'qr/activate',
        getInfo: 'qr/getInfo',
        scan: 'qr/scan',
        refresh: 'qr/refresh',
      },
    },
  },
  defaultAppColors: {
    // Light mode:
    //
    bg1: '#FFFFFF',
    bg2: '#EDF0FB',
    btn1Bg: '#0132E1',
    btn1Fill: '#FFFFFF',
    btn2Bg: '#181818',
    btn2Fill: '#FFFFFF',
    drawerBg: '#FFFFFF',
    drawerTxt: '#181818',
    footBg: '#FFFFFF',
    hdrBg1: '#FFFFFF',
    hdrBg2: '#EDF0FB',
    inputBg: '#FFFFFF',
    mainBtnBg1: '#0132E1',
    mainBtnBg2: '#1752E3',
    mainBtnPollBg1: '#0E6E8C', // '#0132E1', // '#69585F', // '#19B97C',
    mainBtnPollBg2: '#1188B0', // '#F59E0B', // '#806d75', // '#1B895F',
    mainBtnInfoBg1: '#5B21B6', // '#0132E1', // '#6202d7',
    mainBtnInfoBg2: '#7C3AED', // '#F59E0B', // '#9239ff',
    mainBtnImg: '#FFFFFF',
    mainBtnPollImg: '#FFFFFF',
    mainBtnInfoImg: '#FFFFFF',
    mainBtnSelBg1: '#0A1F80',
    mainBtnSelBg2: '#0C1954',
    mainBtnSelImg: '#FFFFFF',
    mainBtnTxt1: '#FFFFFF',
    mainBtnTxt2: '#FFFFFF',
    msgEventBg1: '#FF881A',
    msgEventBg2: '#FFC24D',
    msgMineBg: '#0132E1',
    msgMineTxt: '#FFFFFF',
    msgOthersBg: '#D0DEFF',
    msgOthersTxt: '#181818',
    navBtnBg: '#0132E1',
    reportBtnBg: '#FFFFFF',
    reportBtnBrdr: '#FF0000',
    reportBtnTxt: '#181818',
    txt: '#181818',

    // Dark mode:
    //
    darkBg1: '#121B23',
    darkBg2: '#293250',
    darkBtn1Bg: '#2F50A3',
    darkBtn1Fill: '#E3E9E5',
    darkBtn2Bg: '#7A726D',
    darkBtn2Fill: '#E3E9E5',
    darkDrawerBg: '#121B23',
    darkDrawerTxt: '#E3E9E5',
    darkFootBg: '#121B23',
    darkHdrBg1: '#121B23',
    darkHdrBg2: '#293250',
    darkInputBg: '#121B23',
    darkMainBtnBg1: '#2F50A3',
    darkMainBtnBg2: '#2B2D33',
    darkMainBtnPollBg1: '#1A5570',
    darkMainBtnPollBg2: '#062A3A',
    darkMainBtnInfoBg1: '#3D1878',
    darkMainBtnInfoBg2: '#1F0842',
    darkMainBtnImg: '#FFFFFF',
    darkMainBtnPollImg: '#FFFFFF',
    darkMainBtnInfoImg: '#FFFFFF',
    darkMainBtnSelBg1: '#172E67',
    darkMainBtnSelBg2: '#2A50A3',
    darkMainBtnSelImg: '#FFFFFF',
    darkMainBtnTxt1: '#E3E9E5',
    darkMainBtnTxt2: '#E3E9E5',
    darkMsgEventBg1: '#6F0B48',
    darkMsgEventBg2: '#880B0B',
    darkMsgMineBg: '#2F50A3',
    darkMsgMineTxt: '#fbf7e3',
    darkMsgOthersBg: '#2b3244',
    darkMsgOthersTxt: '#fbf7e3',
    darkNavBtnBg: '#619FFF',
    darkReportBtnBg: '#121B23',
    darkReportBtnBrdr: '#FF0000',
    darkReportBtnTxt: '#E3E9E5',
    darkTxt: '#E3E9E5',
  },
};
